
 enum LeftClickToggle {
    Detail = 'Detail',
    Join = 'Join'
}

export default LeftClickToggle

